(function (app) {

    
    app.value('signalRServer', 'https://sb.gymevent.uk/');

}(angular.module('app.shared')));